<script setup>
import { ref } from 'vue';
import { usePharmacyStore } from '@/stores/pharmacy';
import { storeToRefs } from 'pinia';
// Import the component
import PharmacyProfileForm from '@/components/Pharmacy/PharmacyProfileForm';

const pharmacyStore = usePharmacyStore();
const { active: pharmacy } = storeToRefs(pharmacyStore);

const pharmacyProfileFormRef = ref(null);

const save = () => {
    if (pharmacyProfileFormRef.value) {
        pharmacyProfileFormRef.value.save(); // Call the save method in PharmacyProfileForm
    }
};
</script>

<template>
<MainContentLayout>
    <template #breadcrumb><BreadCrumb /></template>
    <template #title>{{ $t('label.management_title',{ 'what' : 'Pharmacy Profile' }) }}</template>
    <div>
        <h1 class="text-2xl font-bold mb-4">{{ $t("label.pharmacy_profile") }}</h1>
        <PharmacyProfileForm
            ref="pharmacyProfileFormRef"
            :pharmacy="pharmacy" />

        <div class="mt-6">
            <StyledSaveButton :hide-cancel="true" @save="save" />
        </div>
    </div>
</MainContentLayout>
</template>
